module.exports = __webpack_public_path__ + "static/media/Ankita Singh.1505eec1.jpg";